const localizationData = {
	months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
	days: ['Ma', 'Ti', 'On', 'To', 'Fr', 'Lø', 'Sø'],
	days2: ['Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør', 'Søn']
};

export {
	localizationData
};